import { Nav } from 'react-bootstrap';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import './TutorialsSidebarTabs.css';

const TabIcon = ({ children }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

const ICONS = {
  employee: (
    <TabIcon>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </TabIcon>
  ),
  payroll: (
    <TabIcon>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <line x1="2" y1="10" x2="22" y2="10" />
    </TabIcon>
  ),
  company: (
    <TabIcon>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </TabIcon>
  ),
  user: (
    <TabIcon>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
    </TabIcon>
  ),
  tempedge: (
    <TabIcon>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </TabIcon>
  )
};

const TutorialsSidebarTabs = ({ tabs, activeTab, onSelectTab }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  return (
    <div className="tutorials-sidebar-nav">
      <span className="tutorials-sidebar-label">{tempedgeTranslator('com.tempedge.msg.public.tutorials.section')}</span>
      <Nav variant="pills" className="tutorials-nav-items" onSelect={onSelectTab}>
        {Object.entries(tabs).map(([key, label]) => (
          <Nav.Item key={key}>
            <Nav.Link eventKey={key} className="tutorials-nav-link" active={activeTab === key}>
              {ICONS[key]}
              {label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};

export default TutorialsSidebarTabs;
